import { render, staticRenderFns } from "./taskOrderDetail.vue?vue&type=template&id=0ea3dddd&scoped=true"
import script from "./taskOrderDetail.vue?vue&type=script&lang=js"
export * from "./taskOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./taskOrderDetail.vue?vue&type=style&index=0&id=0ea3dddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea3dddd",
  null
  
)

export default component.exports